export default __webpack_public_path__ + "static/media/gigadeflaton.d49f098d.png";